import { NotificationEventEnum } from '.'
import { NotificationEventItem } from './NotificationEventItem'

const AnyConcreteBreak = new NotificationEventItem({
  id: '382712ad-9807-41da-9e17-388cf9e4244e',
  name: 'Any Concrete Break',
  description: 'Any change is made to concrete break data',
})
const ConcreteBreakFailed = new NotificationEventItem({
  id: '93417292-cf09-45e0-8f9b-0ec368a624ca',
  name: 'Concrete Break Failed',
  description:
    'The average 28 day strength of concrete break data fails to fall between the Low Failure Break Strength and Max Break Strength',
})

export type ConcreteNotificationEventItem =
  | typeof AnyConcreteBreak
  | typeof ConcreteBreakFailed

class ConcreteNotificationEventEnum extends NotificationEventEnum<
  'ConcreteNotification',
  ConcreteNotificationEventItem,
  ConcreteNotificationEventItem['name'],
  ConcreteNotificationEventItem['id']
> {
  readonly typename = 'ConcreteNotification'
  get values() {
    return [this.AnyConcreteBreak, this.ConcreteBreakFailed]
  }
  readonly AnyConcreteBreak = AnyConcreteBreak
  readonly ConcreteBreakFailed = ConcreteBreakFailed
}

export const ConcreteNotificationEvent = new ConcreteNotificationEventEnum()
